
export const getPermissions = (module) => {
    const userRole = localStorage.getItem('userRole');
    const permissions = JSON.parse(localStorage.getItem('permissions')) || []; // Ensure it's an array
    if (userRole == 'super-admin' || (permissions && permissions.includes(module))) {
        return true;
    }
    return false;
};

export const getModulePermissions = ({module, type}) => {
    const userRole = localStorage.getItem('userRole');
    const modulePermissions = JSON.parse(localStorage.getItem('module_permissions')) || {};
    if (userRole == 'super-admin') {
        return true;
    }
    if (Array.isArray(modulePermissions[module])) {
        if (type == null) {
            // If type is not provided, check if module has any permissions
            return modulePermissions[module].length > 0;
        } else {
            // If type is provided, check if type exists in module's permissions
            return modulePermissions[module].includes(type);
        }
    }
    return false;
}